import { inject, NgZone, provideAppInitializer } from '@angular/core';
import { provideHighcharts } from 'highcharts-angular';

let ngZone: NgZone | undefined;

/**
 * Provides the configured Highcharts instance (modules, regression plugin, theme) to
 * highcharts-angular.
 *
 * highcharts-angular 5 dropped the `runOutsideAngular` input that every chart in the
 * app used, so the chart constructor is wrapped here instead: Highcharts attaches its
 * pointer and resize listeners while constructing the chart, and running that inside
 * the Angular zone would trigger change detection on every mouse move over a chart.
 */
export function provideMddHighcharts() {
    return [
        provideAppInitializer(() => {
            ngZone = inject(NgZone);
        }),
        provideHighcharts({
            instance: async () => {
                const highcharts = (await import('@mdd/elements/lib/highcharts')).default;
                const chartOutsideAngular = (...args: any[]) =>
                    ngZone
                        ? ngZone.runOutsideAngular(() => (highcharts.chart as any)(...args))
                        : (highcharts.chart as any)(...args);

                return Object.assign(Object.create(highcharts), {
                    chart: chartOutsideAngular
                }) as typeof highcharts;
            }
        })
    ];
}
